module.exports = __webpack_public_path__ + "img/pc_leaf_R.1e17f73.webp";